import { Breadcrumbs, Grid, Link, Typography } from '@mui/material'
import { PADDING_BASE } from '../../assets/Styles'
import TitlebarAction from '../../components/common/TitlebarActions'
import TicketCreate from '../../components/TicketCreate'
import TopSideBar from '../../components/TopSideBar'
import PageContainer from '../../components/common/PageContainer'
import Copyright from '../../components/common/Copyright'


export default function TicketCreatePage(props: any) {
  const { setBlockScreen } = props

  return (<>
    <TopSideBar currentSection='tickets' disableProjectSelector />

    <PageContainer>

      <Grid paddingBottom={PADDING_BASE}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="darkgreen" href="/tickets/listing">
            Home
          </Link>
          <Link underline="hover" color="darkgreen" href="/tickets/listing">
            Tickets
          </Link>
          <Typography color="darkgreen" fontWeight="bold">
            Nuevo
          </Typography>
        </Breadcrumbs>
      </Grid>

      <TitlebarAction
        title='Nuevo Ticket'
      />

      <TicketCreate
        setBlockScreen={setBlockScreen}
      />
      <Copyright />

    </PageContainer>
  </>)
}